import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTopics, selectTopicsState } from '../store/topics/slice';
import { AppDispatch } from '../store';
import { Topic, OrganizationReference } from '../types/topic';

export const useTopics = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { items, loading, error } = useSelector(selectTopicsState);

  const topics: Topic[] = items.map(item => ({
    ...item,
    status: 'public',
    organization: typeof item.organization === 'string' ? item.organization : (item.organization as OrganizationReference)?.id || '',
    parent: item.parent || null,
    children: item.children || [],
    createdAt: new Date(item.createdAt),
    updatedAt: new Date(item.updatedAt)
  }));

  useEffect(() => {
    if (!items.length && !loading && !error) {
      dispatch(fetchAllTopics());
    }
  }, [dispatch, items.length, loading, error]);

  return {
    topics,
    loading,
    error,
    refetch: () => dispatch(fetchAllTopics())
  };
}; 